import {create} from 'zustand';
import {LivenessAction} from '@chekin/core';
import {LivenessState, LivenessStep, StepStatus} from '../types';

interface LivenessStore extends LivenessState {
  setCurrentStep: (step: LivenessStep) => void;
  setStepStatus: (status: StepStatus) => void;
  setFaceScreenshot: (screenshot: string | null) => void;
  setRecordingVideo: (video: Blob | null) => void;
  setIsBlinked: (isBlinked: boolean) => void;
  incrementAttempts: () => void;
  resetAttempts: () => void;
  setCurrentChallenge: (action: LivenessAction | null) => void;
  setRecordingStartTime: (time: number | null) => void;
  resetState: () => void;
  setCompletedActions: (actions: LivenessAction[]) => void;
}

const INITIAL_STATE: LivenessState = {
  currentStep: 'LOOK_STRAIGHT',
  stepStatus: 'idle',
  faceScreenshot: null,
  recordingVideo: null,
  attempts: 0,
  isBlinked: false,
  currentChallenge: null,
  recordingStartTime: null,
  completedActions: [],
};

export const useLivenessStore = create<LivenessStore>(set => ({
  ...INITIAL_STATE,

  setCurrentStep: step => set({currentStep: step}),

  setStepStatus: status => set({stepStatus: status}),

  setFaceScreenshot: screenshot => set({faceScreenshot: screenshot}),

  setRecordingVideo: video => set({recordingVideo: video}),

  setIsBlinked: isBlinked => set({isBlinked}),

  incrementAttempts: () => set(state => ({attempts: state.attempts + 1})),

  resetAttempts: () => set({attempts: 0}),

  setCurrentChallenge: action => set({currentChallenge: action}),

  setRecordingStartTime: time => set({recordingStartTime: time}),

  resetState: () => set(INITIAL_STATE),

  setCompletedActions: actions => set({completedActions: actions}),
}));
